import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataClickArea,
  AnalyticsDataClickPathSocialMedia,
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventClickSocial,
} from 'src/types/googleAnalyticsEvents';

type SocialMediaType = keyof typeof AnalyticsDataClickPathSocialMedia;

export function useEventClickSocial(
  mediaType: SocialMediaType,
  clickArea: AnalyticsDataClickArea = AnalyticsDataClickArea.content,
): AnalyticsEventClickSocial {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.clickSocial,
      [AnalyticsDataProperty.clickArea]: clickArea,
      [AnalyticsDataProperty.clickPath]: AnalyticsDataClickPathSocialMedia[mediaType],
      ...trackedPageContext,
    }),
    [clickArea, mediaType, trackedPageContext],
  );
}
